<!-- MoreAbout.vue -->
<template>
    <section id="moreAbout" class="more-about">
      <div class="ma-header">
        <p class="kicker" style="font: normal normal normal 24px/29px Merriweather;">En savoir plus</p>
        <h2 class="title" style="font: normal normal normal 40px/29px Merriweather;">Sur Hortense</h2>
      </div>
  
      <!-- Cards -->
      <div
        ref="track"
        class="cards-track"
        @scroll.passive="onScroll"
      >
        <!-- 1: La Green Note -->
        <article class="ma-card">
          <img class="ma-icon" src="../../images/illus green note.png" alt="La Green Note">
          <h3 class="ma-card-title">LA GREEN NOTE</h3>
          <p class="ma-card-text">
            Évaluez votre niveau d’engagement environnemental avec notre outil de diagnostic.
          </p>
          <a href="/green-note-engagement-environnemental/" class="ma-link">EN SAVOIR PLUS</a>
        </article>
  
        <!-- 2: Programme Evergreen -->
        <article class="ma-card">
          <img class="ma-icon" src="../../images/greenFull.svg" alt="Le programme Evergreen">
          <h3 class="ma-card-title">LE PROGRAMME EVERGREEN</h3>
          <p class="ma-card-text">
            Bénéficiez d’un accompagnement sur-mesure pour renforcer vos pratiques durables.
          </p>
          <a href="/programme-evergreen-demarche-environnementale/" class="ma-link">EN SAVOIR PLUS</a>
        </article>
  
        <!-- 3: Label Green Host -->
        <!-- <article class="ma-card">
          <img class="ma-icon" src="../../images/green_host.png" alt="Le label Green Host">
          <h3 class="ma-card-title">LE LABEL GREEN HOST</h3>
          <p class="ma-card-text">
            Rejoignez les adresses éco-exemplaires de notre sélection.
          </p>
          <a href="/label-ecoresponsable-green-host/" class="ma-link">EN SAVOIR PLUS</a>
        </article> -->
      </div>
  
      <!-- Mobile dots -->
      <div class="dots">
        <span :class="['dot', {active: current===0}]"></span>
        <span :class="['dot', {active: current===1}]"></span>
        <!-- <span :class="['dot', {active: current===2}]"></span> -->
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'MoreAbout',
    data() {
      return { current: 0 };
    },
    mounted() {
      // ensure first dot active on mount
      this.onScroll();
    },
    methods: {
      onScroll() {
        const el = this.$refs.track;
        if (!el) return;
        const cardW = el.firstElementChild?.getBoundingClientRect().width || 1;
        const idx = Math.round(el.scrollLeft / (cardW + parseFloat(getComputedStyle(el).gap || 0)));
        this.current = Math.max(0, Math.min(2, idx));
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .more-about {
    font-family: 'Raleway', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
    padding: 2.5rem 1rem 3rem;
  
    .ma-header {
      text-align: center;
      margin-bottom: 1.75rem;
      .kicker { font-weight: 600; font-size: 1.1rem; margin: 0 0 .25rem; }
      .title  { font-weight: 800; font-size: 2.2rem; margin: 0; line-height: 1.15; }
    }
  
    .cards-track {
        display: flex;
        flex-wrap: wrap;
        justify-content: center; 
        gap: 1rem;
        padding: .25rem 0 1rem;

        overflow: visible;
        scroll-snap-type: none;
      }

      .ma-card {
        flex: 0 1 420px;  
        max-width: 420px;
        width: 100%;
      }

  
    .ma-card {
      scroll-snap-align: center;
      flex: 0 0 84%;
      max-width: 420px;
      background: #fff;
      border: 1px solid #e9e9e9;
      box-shadow: 0 6px 16px rgba(0,0,0,.06);
      border-radius: 10px;
      text-align: center;
      padding: 1.25rem;
    }
  
    .ma-icon {
      width: 72px; height: 72px; object-fit: contain; margin: .25rem auto 1rem; display: block;
    }
  
    .ma-card-title {
      font-size: .95rem;
      font-weight: 800;
      letter-spacing: .02em;
      margin: 0 0 .5rem;
    }
  
    .ma-card-text {
      color: #3f3f3f;
      font-size: .95rem;
      line-height: 1.55;
      margin: 0 0 .9rem;
    }
  
    .ma-link {
      font-weight: 700;
      text-decoration: underline;
      color: #2f5a4d;
    }
  
    /* Dots (mobile only) */
    .dots {
      display: flex; justify-content: center; gap: .4rem; margin-top: .25rem;
    }
    .dot {
      width: 8px; height: 8px; border-radius: 999px; background: #b8c6c0; display: inline-block;
      &.active { background: #2f5a4d; }
    }
  
    /* Desktop layout: 3 columns, no horizontal scroll */
    // @media (min-width: 992px) {
    //   .cards-track {
    //     overflow: visible;
    //     display: grid;
    //     grid-template-columns: repeat(3, 1fr);
    //     gap: 1.25rem;
    //     justify-items: center;
    //   }
    //   .ma-card { flex: 0 0 auto; width: 100%; max-width: none; }
    //   .dots { display: none; }
    //   .ma-header .title { font-size: 2.6rem; }
    // }
  }
  </style>  